import { get } from 'lodash-es';

import type { AccountSimple } from '../../financial-services-ui/types/fsui';
import type { RootState } from 'store/root-state';

export const selectAccountInformation = (state: AccountSimple): AccountSimple => state;

export const selectIsWalletApBacked = (state: AccountSimple): boolean => state?.isWalletCreatedAfterAPLaunch;

export const selectAccountInformationAccountInformation = (state: RootState): AccountSimple =>
  selectAccountInformation(get(state, 'accountInformation'));
export const selectAccountInformationIsWalletApBacked = (state: RootState): boolean =>
  selectIsWalletApBacked(get(state, 'accountInformation'));
